export default "__VITE_ASSET__DsxeFC5f__"